import { ApiReducer as api } from 'reactifi-local';

export default {
  api,
};
